import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import { sectionHeadingSx } from '../../theme/mobileLayout'

function GalleryImage({ src, alt, wide = false }) {
  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: 220, sm: 300, md: 360, lg: 400 },
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        flex: wide ? 1 : undefined,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  )
}

export default function ProgramGallerySection({
  title = 'Gallery',
  images = [],
  alwaysShowLoadMore = false,
  loadMoreLink = '/contact',
}) {
  const topRow = images.slice(0, 3)
  const bottomRow = images.slice(3, 5)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 5, md: '80px' }, width: '100%' }}>
      <Typography
        component="h2"
        sx={sectionHeadingSx}
      >
        {title}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px', width: '100%' }}>
        {topRow.length > 0 && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                lg: 'repeat(3, 1fr)',
              },
              gap: '40px',
            }}
          >
            {topRow.map((image) => (
              <GalleryImage key={image.src} src={image.src} alt={image.alt} />
            ))}
          </Box>
        )}

        {bottomRow.length > 0 && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: '40px',
            }}
          >
            {bottomRow.map((image) => (
              <GalleryImage key={image.src} src={image.src} alt={image.alt} wide />
            ))}
          </Box>
        )}
      </Box>

      {alwaysShowLoadMore && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          <PrimaryButton to={loadMoreLink}>
            Load More
          </PrimaryButton>
        </Box>
      )}
    </Box>
  )
}
